import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import HomeMediaSection from '../../../organisms/HomeEditorial/HomeMediaSection';

export default function BandMediaSection({
  id = 'media',
  eyebrow,
  title,
  side,
  tracks = [],
  isEditing = false,
  onUploadTrack,
  onPlayTrack,
  onSeekTrack,
  onDeleteTrack,
  onMoveTrack,
  deletingTrackId = null,
  isReorderingTracks = false,
  uploadAudioLabel,
  deleteTrackLabel,
  moveTrackUpLabel,
  moveTrackDownLabel,
  emptyTitle,
  emptyDescription,
}) {
  const { t } = useTranslation();

  return (
    <HomeMediaSection
      id={id}
      eyebrow={eyebrow || t('bandPage.media.eyebrow', { defaultValue: 'Media' })}
      title={title || t('bandPage.media.title', { defaultValue: 'Tracks and live takes.' })}
      side={side}
      tracks={tracks}
      tracksLabel={t('bandPage.media.tracks', { defaultValue: 'Tracks' })}
      tracksMeta={t('bandPage.media.tracksMeta', { defaultValue: 'Demos and live takes' })}
      isEditing={isEditing}
      onUploadTrack={onUploadTrack}
      onPlayTrack={onPlayTrack}
      onSeekTrack={onSeekTrack}
      onDeleteTrack={onDeleteTrack}
      onMoveTrack={onMoveTrack}
      deletingTrackId={deletingTrackId}
      isReorderingTracks={isReorderingTracks}
      uploadAudioLabel={uploadAudioLabel || t('bandPage.media.uploadTrack', { defaultValue: 'Upload audio' })}
      deleteTrackLabel={deleteTrackLabel || t('bandPage.media.deleteTrack', { defaultValue: 'Delete track' })}
      moveTrackUpLabel={moveTrackUpLabel || t('bandPage.media.moveTrackUp', { defaultValue: 'Move track up' })}
      moveTrackDownLabel={moveTrackDownLabel || t('bandPage.media.moveTrackDown', { defaultValue: 'Move track down' })}
      emptyTracksTitle={emptyTitle || t('bandPage.media.emptyTitle', { defaultValue: 'No tracks yet' })}
      emptyTracksDescription={emptyDescription || t('bandPage.media.emptyDescription', { defaultValue: 'Tracks uploaded by the band will appear here.' })}
    />
  );
}

BandMediaSection.propTypes = {
  id: PropTypes.string,
  eyebrow: PropTypes.node,
  title: PropTypes.node,
  side: PropTypes.node,
  tracks: PropTypes.array,
  isEditing: PropTypes.bool,
  onUploadTrack: PropTypes.func,
  onPlayTrack: PropTypes.func,
  onSeekTrack: PropTypes.func,
  onDeleteTrack: PropTypes.func,
  onMoveTrack: PropTypes.func,
  deletingTrackId: PropTypes.string,
  isReorderingTracks: PropTypes.bool,
  uploadAudioLabel: PropTypes.node,
  deleteTrackLabel: PropTypes.string,
  moveTrackUpLabel: PropTypes.string,
  moveTrackDownLabel: PropTypes.string,
  emptyTitle: PropTypes.node,
  emptyDescription: PropTypes.node,
};
